import { store } from '@/app/store';
import { removeUnreadLabel } from '@/features/chats/model/conversation/reducer';
import { bufferMessages, flushAndDispatch } from './messageBuffer';

/**
 * Always buffer messages.
 * Dispatching is handled by messageBuffer (500ms batching)
 */
export const dispatchMessagesToConversation = ({ chatId, messages, resetUnreadlabel = false, immediate = false }) => {
   if (resetUnreadlabel) {
      store.dispatch(removeUnreadLabel({ chatId }));
   }

   bufferMessages(chatId, messages);

   if (immediate) {
      flushAndDispatch(chatId);
   }
};
